import { useEffect, useMemo, useState, useRef } from 'react';
import L, { Control } from 'leaflet';
import { createControlComponent } from "@react-leaflet/core";
import * as ReactLeaflet from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import '@mui/icons-material/'
import 'leaflet-draw/dist/leaflet.draw.css'
import { EditControl } from "react-leaflet-draw"
import { useMap } from 'react-leaflet/hooks'

import styles from './Map.module.css';

import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

const { MapContainer, TileLayer, FeatureGroup } = ReactLeaflet;
var defaultCenter = null;
var defaultZoom = null;

const EditComponent = (props) => {
  const [geoBounds, setGeoBounds] = useState([]);
  const [featureRef, setFeatureRef] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const selectedProfile = props.selectedProfile;
  const setSelectedProfile = props.setSelectedProfile;
  const map = useMap();
  const regionBenchmark = useRef([]);

  const createLayerObject = (layer) => {
    let layerId = L.stamp(layer);
    const corners = layer.getBounds();
    const ne = corners.getNorthEast();
    const sw = corners.getSouthWest();
    const layerObject = {id:layerId, southwest:{latitude:sw.lat,longitude:sw.lng}, northeast:{latitude:ne.lat,longitude:ne.lng}};
    return layerObject;
  }

  const _onCreated = (e) => {
    let layer = e.layer;
    setGeoBounds(regionBenchmark.current);
    if(null == geoBounds) geoBounds = [];
    const layerObject = createLayerObject(layer);
    console.log('Created layer object: ', layerObject);
    setGeoBounds(geoBounds => { return geoBounds.concat([layerObject]) });
    regionBenchmark.current = [...regionBenchmark.current, layerObject];
    console.log('RegionBenchmark Updated(create) :', regionBenchmark.current);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_API_HOST + "/account/user", {
          method: 'GET'
        });
        const userData = await res.json();
        setUser(userData); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData(); // Call the async function here
  }, []); 

  useEffect(() => {
    if(map && featureRef) { 
      featureRef.clearLayers();
      regionBenchmark.current = [];
      selectedProfile.extRegions.forEach(region => {
        let geom = [[region.northeast.latitude,region.northeast.longitude],[region.southwest.latitude,region.southwest.longitude]];
        var rect = new L.Rectangle(geom);
        featureRef.addLayer(rect, { id: region.id || generateId() });
      })
      console.log("featureRef initialized: ", featureRef);
      if(featureRef.getLayers()){
        const normalizedRegions = featureRef.getLayers().map(region => {
        const bounds = region.getBounds();
        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
          return {
            id: generateId(),
            southwest: { latitude: sw.lat, longitude: sw.lng },
            northeast: { latitude: ne.lat, longitude: ne.lng }
          };
        });
        regionBenchmark.current = normalizedRegions;
        console.log("RegionBenchmark initialized: ", regionBenchmark);
      }
      setLoading(false);
    }else{
      regionBenchmark.current = selectedProfile.extRegions.map(region => {
          return {
            id: generateId(),
            southwest: { latitude: region.southwest.latitude, longitude: region.southwest.longitude },
            northeast: { latitude: region.northeast.latitude, longitude: region.northeast.longitude }
          };
      });    
      console.log("RegionBenchmark initialized 2 : ", regionBenchmark);
      setGeoBounds(geoBounds => {return geoBounds.concat(regionBenchmark.current )});
    }
  },[map,featureRef,selectedProfile])

  //id for testing
  const generateId = () => {
    return 'region-' + Math.random().toString(36).substr(2, 9);
  };

  useEffect(() => {
    if(!loading && geoBounds) {
      let mySelectedProfile = {...selectedProfile}
      mySelectedProfile.regions =[];
      mySelectedProfile.extRegions = [];
      regionBenchmark.current.forEach(bound => { //geoBounds
        mySelectedProfile.extRegions.push({southwest:{latitude:bound.southwest.latitude,longitude:bound.southwest.longitude}, northeast:{latitude:bound.northeast.latitude,longitude:bound.northeast.longitude}});
      });
      setSelectedProfile({ ...mySelectedProfile });
    }
  }, [geoBounds]);

  const _onEdited = (e) => {
    console.log("onEdited e: ", e);
    let newGeoBounds = [];
    let existingBounds = selectedProfile.extRegions || [];
    if(null == geoBounds) geoBounds = [];
    e.layers.eachLayer((layer) => {
          newGeoBounds.push(createLayerObject(layer));
          setGeoBounds(geoBounds => { return geoBounds.concat([createLayerObject(layer)]) });

    })
    setGeoBounds(geoBounds => {return geoBounds.concat(regionBenchmark.current )});
    regionBenchmark.current = [...regionBenchmark.current, ...newGeoBounds];
    console.log('RegionBenchmark Updated(edit) :', regionBenchmark.current);
  };

  const _onDeleted = (e) => {
    let removedGeoBounds = [];
    
    e.layers.eachLayer((layer) => {
      //Goes through each of the layers that got deleted
      removedGeoBounds.push(createLayerObject(layer));
    });
     console.log('removed GeoBounds: ', removedGeoBounds);
     setLoading(true);
    setGeoBounds(prevGeoBounds => {
      console.log('oldGeoBounds :', prevGeoBounds);
      const updatedBounds = prevGeoBounds.filter(updatedBound => {
        // Check if there's no corresponding object in removedGeoBounds
        // Perform modifications on updatedBounds
        return !removedGeoBounds.some(removedBound =>
          removedBound.northeast.latitude === updatedBound.northeast.latitude &&
          removedBound.northeast.longitude === updatedBound.northeast.longitude &&
          removedBound.southwest.latitude === updatedBound.southwest.latitude &&
          removedBound.southwest.longitude === updatedBound.southwest.longitude
        );
      });
      return updatedBounds;
    });

    regionBenchmark.current = regionBenchmark.current.filter(benchmarkRegion => 
        !removedGeoBounds.some(removedBound =>
          removedBound.northeast.latitude === benchmarkRegion.northeast.latitude &&
          removedBound.northeast.longitude === benchmarkRegion.northeast.longitude &&
          removedBound.southwest.latitude === benchmarkRegion.southwest.latitude &&
          removedBound.southwest.longitude === benchmarkRegion.southwest.longitude
        )
      );
      console.log("RegionBenchmark Updated(delete) :", regionBenchmark.current);
      setLoading(false);
    
  };

  const _onFeatureGroupReady = (reactFGref, regions) => {
    if(!reactFGref ) {
      return;
    }
    setFeatureRef(reactFGref);
  };

  return (
    <FeatureGroup
      ref={(reactFGref) => {
        _onFeatureGroupReady(reactFGref);
      }}
    >
      <EditControl
        onEdited={_onEdited}
        onCreated={_onCreated}
        onDeleted={_onDeleted}
        draw={{
          polyline: false,
          circle: false,
          polygon: false,
          marker: false,
          circlemarker: false,
          rectangle: true
        }}
      />
    </FeatureGroup>
  )
}

const testbounds = [
  [42.31709570830395,-88.05988401628522],
  [42.4184137949694,-87.94746603849676]
]

const MapComponent = (props) => {
  const [map, setMap] = useState(null);
  const [mapSetupComplete, setMapSetupComplete] = useState(false);
  const center = props.center;
  const zoom = props.zoom;
  const setIsDefault = props.setIsDefault
  defaultCenter = props.defaultCenter;
  defaultZoom = props.defaultZoom;
  let mapClassName = styles.map;
  const selectedProfile = props.selectedProfile;
  const setSelectedProfile = props.setSelectedProfile;

  useEffect(() => {
    (async function init() {
      delete L.Icon.Default.prototype._getIconUrl;

      L.Icon.Default.mergeOptions({
        iconRetinaUrl: iconRetinaUrl.src,
        iconUrl: iconUrl.src,
        shadowUrl: shadowUrl.src,
      });
    })();
  }, []);

  useEffect(() => {
    if (null !== map) {
      map.setView(new L.LatLng(center[0], center[1]), zoom);
    }
  }, [center, zoom])

  const displayMap = useMemo(
    () => (
      <MapContainer center={center} zoom={zoom} zoomControl={true} scrollWheelZoom={false} className={mapClassName} ref={setMap}>
      {defaultCenter && defaultZoom && <ResetControl position="topright"></ResetControl>}
      <EditComponent position="topright" selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile} />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
    </MapContainer>
    ),
    [selectedProfile]
  )

  return (
    <>{displayMap}</>
     
  )
}

Control.Reset = Control.extend({
  onAdd: (map) => {
    var controlDiv = L.DomUtil.create('div', 'leaflet-control-zoom leaflet-bar leaflet-control');
    L.DomEvent
      .addListener(controlDiv, 'click', L.DomEvent.stopPropagation)
      .addListener(controlDiv, 'click', L.DomEvent.preventDefault)
      .addListener(controlDiv, 'click', function () {
        map.closePopup();
        console.log("resetting to default location: " + defaultCenter);
        map.setView(defaultCenter, defaultZoom);
      });
    var controlUI = L.DomUtil.create('a', 'material-icons material-icons-outlined reset-control', controlDiv);
    controlUI.innerText = "restart_alt";
    controlUI.title = 'Reset Map';
    return controlDiv;
  }
})

const ResetControl = createControlComponent(
  (props) => new Control.Reset(props)
);



export default MapComponent;